export enum HeaderIconType {
  WARNING = 'warning-sharp',
  INFO = 'happy-outline',
}
